import React from 'react'
import { Main } from './components'

const Returned = () => <Main />

export default Returned
